import { gql } from '@apollo/client';

export const QUERY_DOCUMENTS = gql`
  query documents {
    documentTypes {
      id
      code
      name
      sortOrder
      subdocs: childObjects {
        id
        code
        name
        country {
          id
          code
        }
      }
    }
  }
`;
